import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Route } from "./Route";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import { Export } from "../pages/Export";
import { HealthCheck } from "../pages/HealthCheck";
import { AccessControl } from "../pages/AccessControl";
import { Dashboard } from "../pages/Dashboard";
import { DashboardOrcamentos } from "../pages/DashboardOrcamentos";
import { BlacklistConfig } from "../pages/DashboardOrcamentos/BlacklistConfig";
import { Reports } from "../pages/reports";
import NewPassword from "../pages/NewPassword";
import ConfirmNewUser from "../pages/ConfirmNewUser";
import { Partners } from "../pages/Partners";
import Project from "../pages/Project";
import Projects from "../pages/Projects";
import { Routines } from "../pages/Routines";
import { ProfilePage } from "../pages/Profile";
import { HomePage } from "../features/home";
import { TimeEfficiencyDashboardPage } from "../features/time-efficiency";

const Routes: React.FC = () => (
  <>
    <Switch>
      <Route path="/login" exact component={Login} />
      <Route
        path="/export"
        exact
        isPrivate
        hasSideBar={false}
        component={Export}
      />
      <Route path="/esqueci" exact component={ForgotPassword} />
      <Route path="/nova-senha" exact component={NewPassword} />
      <Route path="/confirmar-novo/:token" exact component={ConfirmNewUser} />
      <Route path="/inicio" isPrivate exact component={HomePage} />
      <Route path="/access-control" isPrivate exact component={AccessControl} />
      <Route path="/profile" isPrivate exact component={ProfilePage} />
      <Route path="/routines" isPrivate exact component={Routines} />
      <Route path="/reports" isPrivate exact component={Reports} />
      <Route path="/partners" isPrivate component={Partners} />
      <Route path="/projetos" isPrivate component={Projects} />
      <Route path="/projeto" isPrivate component={Project} />
      <Route
        path="/dashboard/orcamentos/blacklist"
        isPrivate
        adminOnly
        exact
        component={BlacklistConfig}
      />
      <Route
        path="/dashboard/orcamentos"
        isPrivate
        exact
        component={DashboardOrcamentos}
      />
      <Route
        path="/dashboard/tempo-eficiencia"
        isPrivate
        exact
        component={TimeEfficiencyDashboardPage}
      />
      <Route path="/dashboard" isPrivate exact component={Dashboard} />
      <Route path="/health" exact component={HealthCheck} />

      {/* <Route path="/test" isPrivate exact component={TestPage} /> */}
      <Route path="*" component={Login} />
    </Switch>
  </>
);

export { Routes };
